export default ( to, from, next ) => {
    if ( localStorage.getItem( 'activeCompany' ) != null && localStorage.getItem( 'activeCompany' ).length > 0 ) {
        // verify with firebase or jwt
        next()
    } else {
        localStorage.removeItem( 'activeCompany' )
        next( '/companies' )
    }
}